import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { handleLoginPageRedirection } from 'lib/authentication/Logout'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const GetParticipantTagsURL = `/participant_tags`

const participantTagsEndPoint = {
  getParticipantTags: () => {
    return axiosRequest().get(GetParticipantTagsURL)
  },
}

const participantTagsAPI = {
  getParticipantTags: (params = {}) =>
    apiWrapper({
      endPoint: participantTagsEndPoint.getParticipantTags,
      params,
      errorFailureAction: handleLoginPageRedirection,
    }),
}

export default participantTagsAPI
